import { render, staticRenderFns } from "./Module3.vue?vue&type=template&id=7615ff93&"
import script from "./Module3.vue?vue&type=script&lang=js&"
export * from "./Module3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports